export const adminRoot = '/admin';